import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getClinicPortalLinks } from "../../../utils/clinicPortalLinks";
import { redirectToClinicPortal } from "../../../utils/portalHost";
import PlatformAuthShell from "../Auth/PlatformAuthShell";
import Button from "../../ui/Button";
import AuthButtonLink from "../Auth/AuthButtonLink";
import a from "../Auth/auth.module.css";

function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Скопируйте ссылку:", text);
    }
  };

  return (
    <Button type="button" variant="ghost" size="md" onClick={copy}>
      {copied ? "Скопировано" : "Копировать"}
    </Button>
  );
}

export default function ClinicCreatedSuccess() {
  const navigate = useNavigate();
  const { tenant, isAuth, role } = useSelector((state) => state.auth);
  const links = getClinicPortalLinks(tenant?.subdomain);

  useEffect(() => {
    if (!isAuth || role !== "admin" || !tenant?.subdomain) {
      navigate("/register-clinic", { replace: true });
    }
  }, [isAuth, role, tenant, navigate]);

  if (!tenant?.subdomain) {
    return null;
  }

  return (
    <PlatformAuthShell
      backTo="/"
      backLabel="На главную"
      title="Клуб создан"
      subtitle={`«${tenant.name || tenant.subdomain}» готов к работе. Сохраните ссылки на кабинеты — ими можно поделиться с командой и клиентами.`}
    >
      <div className={a.successIcon} aria-hidden>
        ✓
      </div>

      <div className={a.linkList}>
        {links.map((item) => (
          <div key={item.id} className={a.linkItem}>
            <div className={a.linkItemTitle}>{item.title}</div>
            <code className={a.linkItemUrl}>{item.url}</code>
            <div className={a.linkItemActions}>
              <CopyButton text={item.url} />
              <AuthButtonLink
                href={item.url}
                block={false}
                target="_blank"
                rel="noopener noreferrer"
              >
                Открыть
              </AuthButtonLink>
            </div>
          </div>
        ))}
      </div>

      <div className={a.actions}>
        <Button
          type="button"
          block
          size="lg"
          onClick={() =>
            redirectToClinicPortal(tenant.subdomain, "/manage/app/venues")
          }
        >
          В панель клуба
        </Button>
        <AuthButtonLink to="/register-clinic" variant="ghost">
          На главную
        </AuthButtonLink>
      </div>
    </PlatformAuthShell>
  );
}
